import { render, staticRenderFns } from "./ProgramacaoRegiao.vue?vue&type=template&id=767c131c"
import script from "./ProgramacaoRegiao.vue?vue&type=script&lang=js"
export * from "./ProgramacaoRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports